<!-- TdtMap.vue -->
<template>
  <div ref="mapContainer" style="width: 100%; height: 500px;"></div>
</template>

<script>
export default {
  name: 'SelectTiandituPos',
  data() {
    return {
      map: null,
      tiandituKey: '4c7d42787aaf263488ae749c9dcb547f',
      marker: null
    }
  },
  mounted() {
    this.loadTianDiTuScript().then(() => {
      // this.initMap();
    }).catch(err => {
      console.error('加载天地图失败:', err);
    });
  },
  beforeDestroy() {
    if (this.map) {
      // 清理地图实例（天地图官方未提供 destroy 方法，但可清空容器）
      this.map = null;
    }
  },
  methods: {
    loadTianDiTuScript() {
      return new Promise((resolve, reject) => {
        // 检查是否已加载
        /* eslint-disable no-undef */
        if (window.T) {
          resolve();
          return;
        }
        /* eslint-enable no-undef */

        /* eslint-disable no-undef */
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${this.tianditukey}`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load TianDiTu script'));
        document.head.appendChild(script);
        /* eslint-enable no-undef */
      });
    },
    initMap(options = {}) {
      // 初始化地图
      /* eslint-disable no-undef */
      const map = new T.Map(this.$refs.mapContainer);

      // 设置中心点和缩放级别（默认为北京，或者根据传入参数）
      let centerLng = options.lng || null;
      let centerLat = options.lat || null;
      let zoom = options.zoom || 14;

      if (centerLng&&centerLat){
        let point = new T.LngLat(centerLng, centerLat);
        let marker = new T.Marker(point);
        map.addOverLay(marker);
        this.marker = marker;
        map.centerAndZoom(point, zoom);
      }else {
        // 尝试获取用户地理位置
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
              (position) => {
                let lng = position.coords.longitude;
                let lat = position.coords.latitude;

                // 在天地图上添加标记
                let point = new T.LngLat(lng, lat);
                let marker = new T.Marker(point);
                map.addOverLay(marker);
                this.marker = marker;
                // 地图中心移到用户位置
                map.centerAndZoom(point, 14);
                // that.$emit('position-change', { lng, lat });
              },
              (error) => {
                console.error("获取位置失败:", error.message);
                // alert("无法获取您的位置，请检查权限或使用支持的浏览器。");
                map.centerAndZoom(new T.LngLat(116.40969, 39.897494), 14);
              },
              {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 60000
              }
          );
        } else {
          alert("您的浏览器不支持地理位置定位。");
        }
      }

      /* eslint-enable no-undef */

      this.map = map;
      
      // 添加点击事件监听器
      this.addClickEvent();
    },
    addClickEvent() {
      /* eslint-disable no-undef */
      this.map.addEventListener("click", (event) => {
        const lng = event.lnglat.lng;
        const lat = event.lnglat.lat;
        
        // 如果存在旧标记，移除它
        if (this.marker) {
          this.map.removeOverLay(this.marker);
        }
        
        // 创建新标记并添加到地图
        const marker = new T.Marker(new T.LngLat(lng, lat));
        this.map.addOverLay(marker);
        this.marker = marker;
        
        // 触发自定义事件，将坐标传递给父组件
        this.$emit('position-change', { lng, lat });
      });
      /* eslint-enable no-undef */
    },
    // 提供一个方法用于外部初始化地图
    initMapFromParent(options = {}) {
      this.initMap(options);
    }
  },
  computed: {
    tianditukey() {
      return this.tiandituKey; // 避免大小写问题
    }
  }
}
</script>

<style scoped>
/* 可选样式 */
</style>